<script setup lang="ts">
import { usePageStore } from '@voix/store/pageStore'
import type { ElementInterface } from '@voix/types'
import { computed, defineProps, ref } from 'vue'
import { useVoixToast } from '@voix/composables/useVoixToast'

const props = defineProps<{
  element: ElementInterface
}>()

const pageStore = usePageStore()
const voixToast = useVoixToast()

const elementTags = computed(() => props.element.tags || ['space', 'martians'])

const newTag = ref('')
const newTagPoint = ref(1)
const requestAddXPTag = ref(false)
function addSliceXPTag() {
  const tag = {name: newTag.value.trim(), point: newTagPoint.value }

  const foundTag = elementTags.value.find(t => t.name === tag.name)

  if (foundTag) {
    voixToast.add(`Tag already added`, 'error')
    return
  }

  pageStore.addXPTagToElement(props.element.id, tag)
  newTag.value = ''
  requestAddXPTag.value = false
}

function removeSliceXPTag(tag: string) {
  pageStore.removeXPTagFromElement(props.element.id, tag)
}
</script>

<template>
  <div class="text-sm border-b border-gray-200 mb-4 pb-2">
    <div class="font-medium voix-admin-text">
      Manage Slice XP Tags
    </div>
    <div>
      These are the tags that are applied to the slice. When the slice comes into the viewport a count is added to this tag.
    </div>
    <div class="flex justify-end">
      <button class="py-2 px-3 text-xs voix-admin-bg-dark voix-admin-text-lightest rounded-sm" @click="requestAddXPTag = !requestAddXPTag">
        {{ requestAddXPTag ? 'Cancel new Tag' : 'Add Tag' }}
      </button>
    </div>
  </div>

  <div v-if="requestAddXPTag">
    <div class="flex items-center justify-between">
      <input v-model="newTag" type="text" class="border border-gray-200 rounded-sm p-2 w-1/2 text-sm" placeholder="Add new tag">
      <input v-model="newTagPoint" type="text" class="border border-gray-200 rounded-sm p-2 w-1/4 text-sm" placeholder="Add new tag">
      <button class="py-2 px-3 text-xs voix-admin-bg-dark voix-admin-text-lightest rounded-sm" @click="addSliceXPTag">
        Add
      </button>
    </div>
  </div>

  <div v-else class="space-y-1">
    <div v-for="tag in elementTags" :key="tag" class="flex justify-between">
      <div class=" flex items-center text-sm">
        {{ tag.name }}
      </div>
      <div class=" flex items-center text-sm">
        Point: {{ tag.point }}
      </div>
      <div>
        <button class="py-2 px-3 text-xs voix-admin-bg-dark voix-admin-text-lightest rounded-sm" @click="removeSliceXPTag(tag)">
          Delete
        </button>
      </div>
    </div>
  </div>
</template>
